import { throwError } from 'rxjs';
import { PermissionConditionSet } from '../services/permission.service';
import { Injector } from '@angular/core';
import { PermissionService } from '../services/permission.service';
import { ToasterService } from "../services/toaster.service";
import { LoadingService } from "../services/loading.service";

let appInjector: Injector;

export function setAppInjector(injector: Injector) {
  appInjector = injector;
}

export function RequiresPermissions(permissionConditionSet: PermissionConditionSet) {
  return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const permissionService = appInjector.get(PermissionService);
      const toasterService = appInjector.get(ToasterService);
      const loadingService= appInjector.get(LoadingService);

      if (!permissionService.evaluatePermissionsForLoggedInUser(permissionConditionSet)) {
        // toasterService.error(`Insufficient privileges.`);
        // return throwError(() => new Error(`Permission denied for ${permissionConditionSet.permissionIds.join(', ')}`));

        loadingService.hide(); // Hide the loader if it was shown
        throw new Error(`Permission denied for ${permissionConditionSet.permissionIds.join(', ')}`);
      }

      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
